import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useSelector } from 'react-redux';
import { SelectFullStateOfThisAPI } from '../../Store/callAPI/selectors';
import { DataKey } from '../../Store/callAPI/allAPIs';
import { MemberInfoAPI } from '../../helpers/APIS/CommonApisSchema';

const ShowLoggedInErrorPopUP = ({ isOpen, toggle }) => {
    const referralMemberAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, MemberInfoAPI));
    const referralData = referralMemberAPIData?.[DataKey]?.data;
    const fullName = referralData?.fullName || 'User';

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle} className="bg-danger text-white p-0 px-4 py-2">
                Login Error
            </ModalHeader>
            <ModalBody>
                <div className="text-center">
                    <p className="mb-0">
                        The user <strong>{fullName}</strong> is already logged in.
                    </p>
                    <p>Please logout and click on the link again.</p>
                </div>
            </ModalBody>
            <ModalFooter className="justify-content-center">
                <Button color="primary" onClick={toggle}>
                    OK
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ShowLoggedInErrorPopUP;
